import React from 'react';
import { injectIntl, FormattedHTMLMessage } from 'gatsby-plugin-intl';
import styled from 'styled-components';

import { device } from "./device";
import H3 from './styledComponents/H3';
import Base from './styledComponents/Base';
import RuleDescription from './styledComponents/RuleDescription';
import IdeaGeneral from './styledComponents/IdeaGeneral';
import ChapterSpace from './styledComponents/ChapterSpace';

import { Container,Cell,Grid,ChapterHeader,ParentAnchor } from './blockComponents';
import { ImageMultilang } from './utility/imageMultilang';

const SubTitle = styled.div`
    font-size: 18px;
    @media ${device.sm} {
        font-size: 24px;
    }
    @media ${device.lg} {
        font-size: 32px;
    }
`;

function ProductTalk({ 
    intl,
    activeAnchor,
    setActiveAnchor,
    pageHeight,
    refs
    }) {
        
    return (
        <ParentAnchor
            key='productTalkSection'
            blockId="productTalk-section"
            blockName='productTalkSection'
            refs={refs}>
            <ChapterHeader title={intl.formatMessage({ id: 'productTalk_title' })}>
                <SubTitle>{intl.formatMessage({ id: 'productTalk_subTitle' })}</SubTitle>
            </ChapterHeader>
            <Container>
                <Grid>
                    <Cell col={12} colXl={10} colXxl={8} leftXl={2} leftXxl={3}>
                        <H3 space="TopDown">{intl.formatMessage({ id: 'productTalk_1' })}</H3>
                        <Base space="Down">{intl.formatMessage({ id: 'productTalk_1_1' })}</Base>
                        <Grid>
                            <Cell col={12} colSm={6}>
                                <RuleDescription />
                                <ImageMultilang 
                                    intl={intl} 
                                    last="sm"
                                    imageRu='productTalk/content-1-no-ru@2x.jpg'
                                    imageUk='productTalk/content-1-no-uk2@2x.jpg'
                                    imageEn='productTalk/content-1-no-en@2x.jpg'/>
                            </Cell>
                            <Cell col={12} colSm={6}>
                                <RuleDescription rule="do" />
                                <ImageMultilang 
                                    intl={intl} 
                                    last="xs"
                                    imageRu='productTalk/content-1-yes-ru@2x.jpg'
                                    imageUk='productTalk/content-1-yes-uk2@2x.jpg'
                                    imageEn='productTalk/content-1-yes-en@2x.jpg'/>
                            </Cell>
                        </Grid>
                        <Base space="TopDown">{intl.formatMessage({ id: 'productTalk_1_2' })}</Base>
                        <Grid>
                            <Cell col={12} colSm={6}>
                                <RuleDescription />
                                <ImageMultilang 
                                    intl={intl} 
                                    last="sm"
                                    imageRu='productTalk/content-2-no-ru@2x.jpg'
                                    imageUk='productTalk/content-2-no-uk@2x.jpg'
                                    imageEn='productTalk/content-2-no1-en@2x.jpg'/>
                            </Cell>
                            <Cell col={12} colSm={6}>
                                <RuleDescription rule="do" />
                                <ImageMultilang 
                                    intl={intl} 
                                    last="xs"
                                    imageRu='productTalk/content-2-yes-ru@2x.jpg'
                                    imageUk='productTalk/content-2-yes-uk@2x.jpg'
                                    imageEn='productTalk/content-2-yes2-en@2x.jpg'/>
                            </Cell>
                        </Grid>

                        <H3 space="TopDown">{intl.formatMessage({ id: 'productTalk_2' })}</H3>
                        <Base space="Down">{intl.formatMessage({ id: 'productTalk_2_1' })}</Base>
                        <Grid>
                            <Cell col={12} colSm={6}>
                                <RuleDescription />
                                <ImageMultilang 
                                    intl={intl} 
                                    last="sm"
                                    imageRu='productTalk/content-3-no-ru@2x.jpg'
                                    imageUk='productTalk/content-3-no-uk@2x.jpg'
                                    imageEn='productTalk/content-3-no-en@2x.jpg'/>
                            </Cell>
                            <Cell col={12} colSm={6}>
                                <RuleDescription rule="do" />
                                <ImageMultilang 
                                    intl={intl} 
                                    last="xs"
                                    imageRu='productTalk/content-3-yes-ru@2x.jpg'
                                    imageUk='productTalk/content-3-yes-uk@2x.jpg'
                                    imageEn='productTalk/content-3-yes-en2@2x.jpg'/>
                            </Cell>
                        </Grid>
                        <Base space="TopDown">{intl.formatMessage({ id: 'productTalk_2_2' })}</Base>
                        <Grid>
                            <Cell col={12} colSm={6}>
                                <RuleDescription />
                                <ImageMultilang 
                                    intl={intl} 
                                    last="sm"
                                    imageRu='productTalk/content-4-no-ru@2x.jpg'
                                    imageUk='productTalk/content-4-no-uk@2x.jpg'
                                    imageEn='productTalk/content-4-no-en@2x.jpg'/>
                            </Cell>
                            <Cell col={12} colSm={6}>
                                <RuleDescription rule="do" />
                                <ImageMultilang 
                                    intl={intl} 
                                    last="xs"
                                    imageRu='productTalk/content-4-yes-ru@2x.jpg'
                                    imageUk='productTalk/content-4-yes-uk@2x.jpg'
                                    imageEn='productTalk/content-4-yes-en@2x.jpg'/>
                            </Cell>
                        </Grid>

                        <H3 space="TopDown">{intl.formatMessage({ id: 'productTalk_3' })}</H3>
                        <Base space="Down">{intl.formatMessage({ id: 'productTalk_3_1' })}</Base>
                        <Base space="Down">{intl.formatMessage({ id: 'productTalk_3_2' })}</Base>
                        <Base space="Down">{intl.formatMessage({ id: 'productTalk_3_3' })}</Base>
                        
                        <Grid>
                            <Cell col={12} colSm={6}>
                                <RuleDescription />
                                <ImageMultilang 
                                    intl={intl} 
                                    last="sm"
                                    imageRu='productTalk/content-5-no-ru@2x.jpg'
                                    imageUk='productTalk/content-5-no-uk@2x.jpg'
                                    imageEn='productTalk/content-5-no-en@2x.jpg'/>
                            </Cell>
                            <Cell col={12} colSm={6}>
                                <RuleDescription rule="do" />
                                <ImageMultilang 
                                    intl={intl} 
                                    last="xs"
                                    imageRu='productTalk/content-5-yes-ru@2x.jpg'
                                    imageUk='productTalk/content-5-yes-uk@2x.jpg'
                                    imageEn='productTalk/content-5-yes2-en@2x.jpg'/>
                            </Cell>
                        </Grid>

                        <H3 space="TopDown">{intl.formatMessage({ id: 'productTalk_4' })}</H3>
                        <IdeaGeneral><FormattedHTMLMessage id="productTalk_4_1" /></IdeaGeneral>
                    </Cell>
                </Grid>
            </Container>
            <ChapterSpace />
        </ParentAnchor>
        
    )
}

export default injectIntl(ProductTalk)